import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useUsers } from "../../../../utils/reactQuery/users";
import Loader from "../../../../components/Loader";
import MuiTable from "../../board/components/BoardTable/MuiTbale";
import { useResponsive } from "../../../../hooks/useResponsive";
import { useAssets } from "../../../../utils/reactQuery/domainAssets";
import { userManagementColumns as columns } from "./userManagementColumns";

function UserTable() {
  const [userType] = useCustomSearchParams("users-type");
  const [userStatus] = useCustomSearchParams("users-status");
  const { isLoading, error, users, isError } = useUsers();
  const data = users?.data?.data?.responseData;
  const isMobile = useResponsive("down", "md");
  const [rows, setRows] = useState([]);
  const searchText = useSelector((state) => state.search.searchText);
  const { icon } = useAssets();

  useEffect(() => {
    const usersArray = data
      ?.map((el, idx) => {
        return {
          ...el,
          id: idx,
          actions: { email: el?.email, userType: el?.user_type },
        };
      })
      ?.filter(
        (user) =>
          user.first_name.toLowerCase().includes(searchText.toLowerCase()) ||
          user.last_name.toLowerCase().includes(searchText.toLowerCase())
      );

    let users = usersArray;
    if (userStatus) {
      if (userStatus == "all") users = usersArray;
      if (userStatus == "active") {
        users = users?.filter((el) => el.active);
      }
      if (userStatus == "inactive") {
        users = users?.filter((el) => !el.active);
      }
    }
    if (userType) {
      if (userType == "all") users = users;
      if (userType == "internal") {
        users = users?.filter((el) => el.user_type == "Internal");
      }
      if (userType == "external") {
        users = users?.filter((el) => el.user_type == "External");
      }
    }
    setRows(users);
  }, [searchText, userType, userStatus, data]);

 
  return (
    <>
      {isLoading && (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && isError && (
        <div className="loader-center">
          <p>Error</p>
        </div>
      )}
      {!isLoading && !isError && (
        <Box p={isMobile && 1} mt={isMobile && 1}>
          <MuiTable
            initialRows={rows || []}
            columns={columns(icon)}
            defaultSort={"first_name"}
            headerBgColor={"#F2F4F6"}
          />
        </Box>
      )}
    </>
  );
}

export default React.memo(UserTable);
